import { render } from "./Formats.vue?vue&type=template&id=24177b12&scoped=true"
import script from "./Formats.vue?vue&type=script&lang=js"
export * from "./Formats.vue?vue&type=script&lang=js"

import "./Formats.vue?vue&type=style&index=0&id=24177b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24177b12"]])

export default __exports__